import { Component } from "react";

import { inject, observer } from "mobx-react";

import styled from "styled-components/macro";

import { AppStore } from "../../stores/AppStore";

const Wrapper = styled.div`
  padding: 10px;
  height: calc(100vh - 130px);
  overflow: auto;
`;
const Title = styled.div`
  margin: 10px 0;
  font-size: 1.5rem;
  font-weight: bold;
`;
const Text = styled.div`
  padding-left: 10px;
  padding-bottom: 10px;
`;

interface TermsPageProps {}

interface InjectedProps extends TermsPageProps {
  appStore: AppStore;
}

@inject("appStore")
@observer
class TermsPage extends Component<TermsPageProps> {
  get injected() { return this.props as InjectedProps; }
  get userStore() { return this.injected.appStore.userStore; }

  render() {
    return (
      <Wrapper>
<h1>Terms of service</h1>

<Title>1. Terms</Title>
<Text>By accessing the website at http://localhost:3000, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</Text>

<Title>2. Use License</Title>
<ul>
  <li>
    <Text>Permission is granted to temporarily download one copy of the materials (information or software) on this website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</Text>
    <ol>
      <li>modify or copy the materials;</li>
      <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
      <li>attempt to decompile or reverse engineer any software contained on this website;</li>
      <li>remove any copyright or other proprietary notations from the materials; or</li>
      <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
    </ol>
  </li>
  <li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Seeso at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li>
</ul>

<Title>3. Disclaimer</Title>
<ul>
  <li>The materials on Seeso's website are provided on an 'as is' basis. Seeso makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</li>
  <li>Further, Seeso does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</li>
</ul>

<Title>4. Limitations</Title>
<Text>In no event shall Seeso or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Seeso's website, even if Seeso or a Seeso authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</Text>

<Title>5. Accuracy of materials</Title>
<Text>The materials appearing on Seeso's website could include technical, typographical, or photographic errors. Seeso does not warrant that any of the materials on its website are accurate, complete or current. Seeso may make changes to the materials contained on its website at any time without notice. However Seeso does not make any commitment to update the materials.</Text>

<Title>6. Links</Title>
<Text>Seeso has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Seeso of the site. Use of any such linked website is at the user's own risk.</Text>

<Title>7. Modifications</Title>
<Text>Seeso may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</Text>

<Title>8. Governing Law</Title>
<Text>These terms and conditions are governed by and construed in accordance with the laws of Brazil and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</Text>
      </Wrapper>
    )
  }
}

export default TermsPage;